import { ArrowPathIcon } from "@heroicons/react/24/solid";
const RefreshButton = ({
  buttonValue = "",
  onClick,
  disabled = false,
  className = "",
}) => {
  return (
    <button
      disabled={disabled}
      onClick={onClick}
      className={
        (disabled
          ? "cursor-not-allowed border text-primary border-primary"
          : "text-primary border-primary") +
        `hover:scale-90 rounded-full gap-x-1 items-center shadow-md bg-white hover:bg-primary text-primary hover:text-white flex flex-row justify-center text-xs font-medium border border-primary py-1 px-1 transition duration-500 ease select-none focus:outline-none focus:shadow-outline ${className}`
      }
    >
      <ArrowPathIcon className=" h-4 w-4" />
      {buttonValue && <div>{buttonValue}</div>}
    </button>
  );
};
export default RefreshButton;
